import axios from 'axios'
import service from './api.js'
import { Toast } from 'vant'
import QS from 'qs'
// import store from '../store/index'

console.log(process.env)
// let baseUrl = ''
// if (process.env.VUE_APP_MODE === 'development') {
//   // 开发环境下的执行操作
//   baseUrl = process.env.VUE_APP_API_URL
// } else {
//   // 生产环境下的执行操作
//   baseUrl = process.env.VUE_APP_API_URL
// }
// service循环输出不同的请求方法
console.log('base_url',window.g.base_url)
const instance = axios.create({
  baseURL: window.g.base_url,
  headers: {
    // 'X-Requested-With': 'XMLHttpRequest',
    'content-type': 'application/x-www-form-urlencoded'
  },
  timeout: 30000
})
const Http = {} // 包裹请求方法的容器

// 请求格式、参数的统一
for (const i in service) {
  const api = service[i] // url method
  Http[i] = async function (
    // 请求参数 get：url，put，post，patch（data），delete：url
    params,
    isFormData = false, // 是否是formdata
    config = {} // 配置参数
  ) {
    // let url = api.url
    // 判断是否是formData， 如果是 转成form-data的格式
    let newParams = {}
    // console.log(params)
    // content-type 是否是form-data的判断
    if (params && isFormData) {
      newParams = new FormData()
      for (const j in params) {
        newParams.append(j, params[j])
      }
      // console.log(555, newParams,api.url)
    } else {
      newParams = params
      // console.log(777,api.url)
    }
    // 不同请求的判断
    let response = {} // 请求的返回值
    if (api.method === 'put' || api.method === 'post' || api.method === 'patch') {
      try {
        // qs.stringify()将对象 序列化成URL的形式，以&进行拼接
        response = await instance[api.method](api.url, QS.stringify(newParams), config)
        // console.log('response',response)
      } catch (err) {
        response = err
      }
    } else if (api.method === 'delete' || api.method === 'get') {
      config.params = newParams
      // console.log('33333', config.params)
      // config.data = newParams
      try {
        // console.log('zheili')
        response = await instance[api.method](api.url, config)
      } catch (err) {
        response = err
      }
    }
    return response
  }
}

// 拦截器的添加
// 请求拦截器
instance.interceptors.request.use(config => {
  // 请求发起前处理
  // alert('我要发请求啦')
  Toast.loading({
    mask: false,
    duration: 0, // 一直存在
    forbidClick: true, // 禁止点击
    message: '加载中...'
  })
  //     // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
  // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
  // qs.parse()将URL解析成对象的形式

  if (localStorage.getItem('token') != 'undefined'){
    const token = localStorage.getItem('token')
    // console.log(token)
    if (token != null) {
      // console.log('token 非空')
      token && (config.headers.Authorization = token)
    } else {
      // console.log('token 为空',9999)
    }
  }
  // const token = 'oOD401jXPWZchJhQqkBtHaQYDn4M'
  return config
}, err => {
  // 请求错误
  Toast.clear()
  // Toast('请求错误，请稍后再试')
  console.log(err)
  // 请求错误时做些事
  return Promise.reject(err);
})
// 响应拦截器
instance.interceptors.response.use(res => {
  // 响应成功
  // alert('请求成功啦')
  Toast.clear()
  return res.data
}, err => {
  // 响应失败
  console.log(err)
  Toast.clear()
  return Promise.reject(err.response.data); // 返回接口返回的错误信息
  // Toast('请求错误，请稍后再试')
})

export default Http
